import type { TI_FileUploadData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIFileUploadData: Omit<
  TI_FileUploadData,
  'selectedVariable'
> = {
  title: 'Default File Upload Title'
};
